import styles from "./About.module.scss";
import { useTranslation } from "react-i18next";
import { classNames } from "primereact/utils";
import { useGetConfigQuery } from "../../app/apiSlice";

export function About() {
  const { data: config } = useGetConfigQuery();
  const { t } = useTranslation();

  return (
    <div className="flex align-items-center justify-content-center w-full">
      <div className="flex align-self-start" style={{ maxWidth: "50%" }} />
      <div style={{ maxWidth: "50%" }}>
        <div className={classNames(styles["white-box"], "p-2")}>
          <div className={classNames(styles.about, "p-2")}>
            <b>@Athea Software</b>
          </div>
          <div className={classNames(styles.about, "p-2")}>
            {t("Datapipeline-ui version")}{config?.datapipelineUiImage ? `: ${config.datapipelineUiImage}` : ""}
          </div>
        </div>
      </div>
    </div>
  );
}
